
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { CvDbService } from 'src/app/services/cv-db/cv-db.service';

@Component({
  selector: 'app-skills',

  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css'],
})
export class SkillsComponent {
  @Input() formGroup!: FormGroup;

  @Output() next = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  langLevel = ['Beginner', 'Intermediate', 'Advanced', 'Fluent', 'Native'];
    constructor(private fb: FormBuilder,private cvDbService:CvDbService) {}
    
  ngOnInit(): void {
    if (this.skills.length === 0) {
      this.addSkill();
    }
    if (this.languages.length === 0) {
      this.addLanguage();
    }
    if (this.certificates.length === 0) {
      this.addCertificat();
    }
    if (this.courses.length === 0) {
      this.addcourse();
    }
    if (this.projects.length === 0) {
      this.addProject();
    }
  }
  get skills(): FormArray {
    return this.formGroup.get('skill') as FormArray;
  }

  addSkill(): void {
    this.skills.push(this.fb.control('', Validators.required));
  }
  removeSkill(index: number): void {
    this.skills.removeAt(index);
  }
  get courses(): FormArray {
    return this.formGroup.get('course') as FormArray;
  }
  addcourse(): void {
    this.courses.push(this.fb.control('', Validators.required));
  }
  removeCourse(index: number): void {
    this.courses.removeAt(index);
  }
  get projects(): FormArray {
    return this.formGroup.get('project') as FormArray;
  }
  addProject(): void {
    this.projects.push(this.fb.control('', Validators.required));
  }
  removeProject(index: number): void {
    this.projects.removeAt(index);
  }
  get certificates(): FormArray {
    return this.formGroup.get('certification') as FormArray;
  }

  addCertificat() {
    const certificat = this.fb.group({
      name: ['', Validators.required],
      organization: ['', Validators.required],
      date: ['', Validators.required],
    });
    this.certificates.push(certificat);
  }
  removeCertificat(index: number): void {
    this.certificates.removeAt(index);
  }

  get languages(): FormArray {
    return this.formGroup.get('languages') as FormArray;
  }
  addLanguage() {
    const lasnguage = this.fb.group({
      name: ['', Validators.required],
      level: ['', Validators.required],
    });
    this.languages.push(lasnguage);
  }
  removeLanguage(index: number): void {
    this.languages.removeAt(index);
  }

 onNext() {
   
   
    this.next.emit();
    

  }
  onPrevious() {
    this.previous.emit();
  }
}
